angular.module('FmsApp').directive('storeSidebarJs', function() {
  return {
    templateUrl:
      '/static/assets/khapps/fms_app/myfarm/map/sidebar/store/store-sidebar.directive.html',
    controller: function() {}
  };
});
